import cn from '../../../utils/cn';
import style from './HorizontalList.module.css';

/**
 * HorizontalList component - Displays items in a horizontal list with configurable gap
 * @param {object} params
 * @param {Array<any>} params.items - Array of items to render
 * @param {(item: any, index: number) => React.ReactNode} params.children - Render function for each item
 * @param {'xs'|'s'|'m'|'l'} [params.gap='s'] - Gap between items
 * @param {string} [params.className] - Additional CSS classes
 * @returns {JSX.Element} HorizontalList component
 */
function HorizontalList({
  items,
  children,
  gap = 's',
  className,
}) {
  return (
    <div className={cn([style.container, style[`gap-${gap}`], className])}>
      {items.map((item, index) => children(item, index))}
    </div>
  );
}

export default HorizontalList;
